import { apiClient } from './client';
import { downloadPdfBlob } from '../utils/downloadPdf';
import {
  QualityPolicyCycle,
  QualityPolicyCycleCreatePayload,
  QualityPolicyDocumentPayload,
} from '../types/qualityPolicy';

export async function fetchQualityPolicyCycles(): Promise<QualityPolicyCycle[]> {
  const { data } = await apiClient.get<QualityPolicyCycle[]>('/quality-policy-cycles');
  return data;
}

export async function fetchQualityPolicyCycle(cycleId: number): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.get<QualityPolicyCycle>(`/quality-policy-cycles/${cycleId}`);
  return data;
}

export async function createQualityPolicyCycle(
  payload: QualityPolicyCycleCreatePayload
): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.post<QualityPolicyCycle>('/quality-policy-cycles', payload);
  return data;
}

export async function updateQualityPolicyPlan(
  cycleId: number,
  payload: QualityPolicyDocumentPayload
): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.patch<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/plan`,
    payload
  );
  return data;
}

export async function updateQualityPolicyDetail(
  cycleId: number,
  payload: QualityPolicyDocumentPayload
): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.patch<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/detail`,
    payload
  );
  return data;
}

export async function updateQualityPolicyReport(
  cycleId: number,
  payload: QualityPolicyDocumentPayload
): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.patch<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/report`,
    payload
  );
  return data;
}

export async function approveQualityPolicyPlan(cycleId: number): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.post<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/plan/approve`
  );
  return data;
}

export async function revokeQualityPolicyPlan(cycleId: number): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.post<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/plan/revoke`
  );
  return data;
}

export async function approveQualityPolicyDetail(cycleId: number): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.post<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/detail/approve`
  );
  return data;
}

export async function revokeQualityPolicyDetail(cycleId: number): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.post<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/detail/revoke`
  );
  return data;
}

export async function approveQualityPolicyReport(cycleId: number): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.post<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/report/approve`
  );
  return data;
}

export async function revokeQualityPolicyReport(cycleId: number): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.post<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/report/revoke`
  );
  return data;
}

export async function closeQualityPolicyCycle(cycleId: number): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.post<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/close`
  );
  return data;
}

export async function reopenQualityPolicyCycle(cycleId: number): Promise<QualityPolicyCycle> {
  const { data } = await apiClient.post<QualityPolicyCycle>(
    `/quality-policy-cycles/${cycleId}/reopen`
  );
  return data;
}

export async function deleteQualityPolicyCycle(cycleId: number): Promise<void> {
  await apiClient.delete(`/quality-policy-cycles/${cycleId}`);
}


export async function downloadQualityPolicyPlanPdf(
  cycleId: number,
  fileName?: string
): Promise<void> {
  await downloadPdfBlob(
    `/quality-policy-cycles/${cycleId}/plan/pdf`,
    fileName || `품질방침계획_${cycleId}.pdf`
  );
}

export async function downloadQualityPolicyDetailPdf(
  cycleId: number,
  fileName?: string
): Promise<void> {
  await downloadPdfBlob(
    `/quality-policy-cycles/${cycleId}/detail/pdf`,
    fileName || `품질방침세부_${cycleId}.pdf`
  );
}

export async function downloadQualityPolicyReportPdf(
  cycleId: number,
  fileName?: string
): Promise<void> {
  await downloadPdfBlob(
    `/quality-policy-cycles/${cycleId}/report/pdf`,
    fileName || `품질방침보고_${cycleId}.pdf`
  );
}
